
angular.module('mtic.components.notifications')
.service('notificationService', function(
    $log,
    api
){   
  this.postUserNotification = function(message_type, user_id, from_user_id, log_state){
    api.postUserNotification(message_type, user_id, from_user_id, log_state)
    .then(function(){
      $log.log('notification created!')
    })
  }
})
